import styled, { css } from 'styled-components'

const PageWrapper = styled.div`
  ${({ theme }) => css`
    display: grid;
    grid-template-columns: 17.875rem minmax(1rem, 1fr);

    max-width: 1366px;
    gap: 32px;

    padding: 24px 64px;
    position: relative;
    margin: 0 auto;

    position: relative;

    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      display: block;
      padding: 16px 20px;
    }
  `}
`

const SidebarWrapper = styled.div`
  ${({ theme }) => css`
    width: 100%;

    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  `}
`

const BodyWrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      display: flex;
      flex-direction: column;
      align-items: center;

      width: 100%;
      max-width: 603px;

      margin: 0 auto;
    }
  `}
`

const ContentWithIcon = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    text-align: center;
    margin-bottom: 24px;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      align-items: flex-start;
      flex-direction: row;
      gap: 44px;
      margin-left: 12px;
      text-align: left;
    }
  `}
`

const WrapperButtons = styled.div<{ $qtdButtons: number; width: string }>`
  ${({ theme, $qtdButtons, width = '100%' }) => css`
    width: ${width};

    grid-area: buttons;

    display: grid;
    grid-template-columns: repeat(${$qtdButtons}, 1fr);

    gap: 32px;
    margin-top: 24px;

    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      margin-top: 24px;

      width: calc(100vw - 40px);

      grid-template-columns: 1fr;
      gap: 24px;
    }

    @media (min-width: 993px) and (max-width: 1150px) {
      display: flex;
    }
  `}
`

export const PagesWrapper = {
  Root: PageWrapper,
  SideBar: SidebarWrapper,
  Body: BodyWrapper,
  ContentWithIcon,
  WrapperButtons
}
